import React from "react";
import { Form, Input } from "antd";
import Uploadfield from "./Uploadfield";

const inputClass = "border-2 border-b-2 rounded-none";

const SellerReplyInputField = ({
  docname,
  needUpload,
  needText,
  form,
  index,
}) => {
  return (
    <>
      <div className="flex flex-row flex-wrap items-center mb-1">
        <label className=" capitalize flex gap-x-4 mr-3 w-fit">
          <pre className="text-xs">{index}.</pre>
          <div className="text-xs">{docname}*</div>
        </label>
        {needText && <div className={"mr-6 flex-grow"}>
          <Form.Item
            name={`${docname}_text`}
            className="m-0 p-0"
            labelAlign="left"
            rules={[
              {
                required: needText,
                message: `Please enter ${docname}`,
              },
            ]}
          >
            <Input className={inputClass} placeholder="Text" />
          </Form.Item>
        </div>}
        {needUpload && <Uploadfield docName={docname} form={form} />}
      </div>
    </>
  );
};

export default SellerReplyInputField;
